import { PROFILE_KEY, updateProfileAction } from '@gymaholic/packages'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from '@gymaholic/packages/src/modules/redux/constants/action.js'

export default function updateEmailProfileAction (value) {
  const key = PROFILE_KEY.EMAIL
  return updateProfileAction({
    type: getActionStrReduxUtil(REDUX_ACTION_PREFIX.UPDATE, key),
    payload: {
      key,
      value: value
    }
  })
}
